export default __webpack_public_path__ + "images/c8ca3e26efad5351b20b9f8eeeb3fe6e.png";